import axios, { AxiosResponse } from 'axios';

export default function getListAsync(apiUrl: string) {
  return function api<TResponse>(
    sorting: string | undefined | null,
    skipCount: number | undefined | null,
    maxResultCount: number | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/sample-type-definitions?sorting=${sorting}&skipCount=${skipCount}&maxResultCount=${maxResultCount}`,
          method: 'GET',
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
